module.exports = __webpack_public_path__ + "static/hero_form-c33c380cf2206eb570763497e1784363.jpg";